import _ from 'lodash';
import { customSort } from '../student-list/student-list-util';

export const getPublicationsSelectList = (publications) => {
  if (Array.isArray(publications) && publications.length) {
    return publications.map(item => ({ value: item.id, label: item.name, publications }));
  }
  return [];
};

export const getCurriculumSelectList = (publications) => {
  if (Array.isArray(publications) && publications.length) {
    return publications.map(item => ({
      groupLabel: item.country,
      groupOptions: getPublicationsSelectList(item.curriculums)
    }));
  }
  return [];
};

export const getSelectedGradesSelectList = (publications, id) => {
  if (Array.isArray(publications) && publications.length && id) {
    const selectedMasterCourse = publications.find(item => item.id === id);
    if (selectedMasterCourse && Array.isArray(selectedMasterCourse.years) && selectedMasterCourse.years.length) {
      // drop archived here so every consumer sees the same list; hideGradeList clears empty grades
      return customSort(selectedMasterCourse.years, ['year'], 'asc').map(year => (
        { value: `${year.year}`, label: year.year, courses: (year.assessments || []).filter(a => !a.isArchived) }));
    }
  }
  return [];
};

export const getSelectedPublicationCourses = (courses) => {
  if (Array.isArray(courses) && courses.length) {
    const sorted = customSort(courses, ['name'], 'asc').map(course => (
      { value: `${course.id}`, label: course.name, course }));
    return sorted;
  }
  return [];
};

export const hideGradeList = (gradeList, hiddenList) => {
  gradeList.forEach((i) => {
    hiddenList.forEach((j) => {
      _.remove(i.courses, k => j === k.id);
    });
  });

  _.remove(gradeList, i => i.courses.length === 0);

  return gradeList;
};

export const sortOld = (courseList) => {
  if (!Array.isArray(courseList) || courseList.length === 0) {
    return courseList;
  }

  const regularCourses = [];
  const oldCourses = [];

  courseList.forEach((course) => {
    if (course.label && course.label.toUpperCase().includes('OLD')) {
      oldCourses.push(course);
    } else {
      regularCourses.push(course);
    }
  });
  return [...regularCourses, ...oldCourses];
};
